var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('label',{attrs:{"for":"fileUpload"}},[_vm._v(_vm._s(_vm.label))]),_c('input',{staticClass:"form-control",attrs:{"type":"file","multiple":"","id":"fileUpload"},on:{"change":function($event){return _vm.onFileChange($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }